import { ReactNode } from "react";

import RLCard from "@components/card/RLCard";
import Typography from "@components/typography/Typography";

import styles from "@modules/network/components/header/header.module.scss";

type Props = {
  threatName?: string;
  fallback?: ReactNode;
};

const ThreatNameCard = ({
  threatName,
  fallback = "No threats found"
}: Props) => (
  <RLCard
    className={styles.header_card}
    header={
      <RLCard.Header className={styles.card_title}>Threat Name</RLCard.Header>
    }
    content={
      <RLCard.Content className="p-0 flex align-items-center justify-content-center">
        <Typography
          variant="h5"
          className="line-height-base text-center word-break-break-all"
          tag="span"
          data-testid="nti_header_threat_name"
        >
          {threatName ?? fallback}
        </Typography>
      </RLCard.Content>
    }
  />
);

export default ThreatNameCard;
